import AbsEditViewValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/AbsEditViewValueFormatter.ts";
import dayjs, {ISO_DATE_FORMATS} from "@/utils/dayjs";

export default class DateValueFormatter extends AbsEditViewValueFormatter {
  private static _instance: DateValueFormatter;

  static instance() {
    if (!this._instance)
      this._instance = new DateValueFormatter();
    return this._instance;
  }

  format(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any) {
    if (!value)
      return '';
    return dayjs(value, ISO_DATE_FORMATS).format("DD-MM-YYYY");
  }

  parse(specs: namaTypes.DTOFieldSpecs | null | undefined, value: any) {
    if (!value || !dayjs(value, ISO_DATE_FORMATS).isValid())
      return '';
    return dayjs(value, ISO_DATE_FORMATS).format("YYYY-MM-DD HH:mm:ss.SSS");
  }
}
